export const LOW_INFRASTRUCTURE_CREDIT_ALERT_AMOUNT = 'low_infrastructure_credit_alert_amount';
export const LOW_SERVICE_CREDIT_ALERT_AMOUNT = 'low_service_credit_alert_amount';
export const GET_CREDIT_ALERTS = 'get_credit_alerts';
export const UPDATE_DATE_TIME = 'update_date_time';
export const UPDATE_TRANSACTION_LIST = 'update_transaction_list';
